export namespace YeshivaEnums.AngularApp.API.enums {
    export enum Area {
        all = 0,
        midrash = 1,
        ask = 2,
    }
    export enum DedicateType {
        MEMORY = 1,
        RECOVER = 2,
        HONOR = 3,
        eMEMORY = 4,
        eRECOVER = 5,
        eHONOR = 6,
        OTHER = 7,
    }
    export enum Limud {
        Non = 0,
        MishnaBrura = 1,
        TalmudBavli = 2,
        TalmudYerushalmi = 3,
        Rambam1 = 4,
        Rambam3 = 5,
        Mishna = 6,
        Emuna = 256,
    }
    export enum MediaType {
        None = 0,
        Text = 1,
        Video = 2,
        Audio = 4,
        PDF = 8,
        Doc = 16,
        Image = 32,
    }
    export enum ContentType {
        All = 0,
        General = 1,
        Woman = 2,
        Children = 4,
    }
    export enum Order {
        asc = 0,
        desc = 1,
    }
    export enum OrderBy {
        none = 0,
        dateUp = 1,
        popularity = 2,
        length = 3,
        counter = 4,
        id = 5,
        rabbi = 6,
        category = 7,
    }
    export enum ReplyType {
        NONE = 0,
        ARTICLE = 1,
        SHIUR = 2,
        QUESTION = 3,
    }
    export enum BeitMidrashType {
        YESHIVA = 1,
        BRACHA = 2,
        NIR = 3,
        BIRCHAT_MOSHE = 4,
        MAALOT = 5,
        BEER_ASHER = 6,
        MISHNA_TORAH = 7,
    }
}
export namespace YeshivaEnums.YeshivaModels.BE {
    /**
     * Should be similar to  update in any change that occour here!!!
     */
    export enum EntityType {
        NONE = 0,
        ARTICLE = 1,
        SHIUR = 2,
        QUESTION = 3,
        FORUMTHREAD = 4,
        TEST = 5,
        BOOK = 6,
        ARTICLE_CATEGORY = 100,
        MIDRASH_CATEGORY = 101,
        ASK_CATEGORY = 102,
        RABBI = 200,
        MIDRASH_RABBI = 201,
        ASK_RABBI = 202,
        ADMIN = 210,
        REGISTERD_USER = 211,
    }
}
export namespace YeshivaEnums.YeshivaModels.Logic.Enums {
    export enum LimudYomiType {
        Non = 0,
        MishnaBrura = 1,
        TalmudBavli = 2,
        TalmudYerushalmi = 3,
        Rambam1 = 4,
        Rambam3 = 5,
        Mishna = 6,
        Emuna = 256,
    }
    export enum TagTemplate {
        None = 0,
        Parasha = 1,
        Moed = 2,
        DafYomi = 3,
        RambamYomi = 4,
        MishnaYomit = 5,
        EmunaYomi = 6,
        Omer = 7,
    }
}
export namespace YeshivaEnums.YeshivaModels.Logic.Globalization {
    export enum Lang {
        He = 1,
        En = 2,
    }
}
